module.exports = __webpack_public_path__ + "static/media/08.f2438314.jpg";